import { render, staticRenderFns } from "./Deauville.vue?vue&type=template&id=aa41af1a&scoped=true"
import script from "./Deauville.vue?vue&type=script&lang=js"
export * from "./Deauville.vue?vue&type=script&lang=js"
import style0 from "./Deauville.vue?vue&type=style&index=0&id=aa41af1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa41af1a",
  null
  
)

export default component.exports